(function () {
  var root = document.getElementById('custom-cart-drawer');
  if (!root) return;

  var overlay = root.querySelector('[data-ccd-overlay]');
  var panel = root.querySelector('.ccd__panel');
  var btnClose = root.querySelector('[data-ccd-close]');
  var itemsEl = root.querySelector('[data-ccd-items]');
  var subtotalEl = root.querySelector('[data-ccd-subtotal]');

  if (typeof window.gsap === 'undefined') {
    console.warn('[CartDrawer] GSAP not found. Include GSAP before this file.');
  }

  var isOpen = false;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.customCartDrawerMoneyFormat || '{{amount}}');
    }
    var value = (cents / 100).toFixed(2);
    return '£' + value;
  }

  function setVisible(on) {
    if (on) {
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
    }
  }

  var tl = null;
  function buildTimeline() {
    if (!window.gsap) return null;
    if (tl) return tl;

    tl = window.gsap.timeline({
      paused: true,
      defaults: { ease: 'power2.out' },
      onStart: function () { setVisible(true); },
      onReverseComplete: function () { setVisible(false); }
    });

    tl.to(overlay, { opacity: 1, duration: 0.25 }, 0)
      .to(panel, { x: '0%', duration: 0.35 }, 0);

    return tl;
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    setVisible(true);
    document.documentElement.classList.add('slimmr-lock-scroll');

    if (window.gsap) {
      window.gsap.set(overlay, { opacity: 0 });
      window.gsap.set(panel, { x: '110%' });
      buildTimeline().play(0);
    } else {
      overlay.style.opacity = '1';
      panel.style.transform = 'translateX(0)';
    }

    setTimeout(function () {
      try { panel.focus(); } catch (e) {}
    }, 50);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    document.documentElement.classList.remove('slimmr-lock-scroll');
    if (window.gsap && tl) {
      tl.reverse();
    } else {
      overlay.style.opacity = '0';
      panel.style.transform = 'translateX(110%)';
      setVisible(false);
    }
  }

  async function getCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function renderEmpty() {
    itemsEl.innerHTML = '<div class="emtpty-cart-note">Your cart is empty.</div>';
    subtotalEl.textContent = formatMoney(0);
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  // ✅ CHANGED: store item.key instead of line index
  function buildItemRow(item) {
    var img = item.image ? item.image : '';
    var title = escapeHtml(item.product_title || item.title || 'Product');
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? escapeHtml(item.variant_title) : '';

    return (
      '<div class="ccd__item" data-key="' + item.key + '">' +
        (img
          ? '<img class="ccd__img" src="' + img + '" alt="' + title + '">'
          : '<div class="ccd__img" aria-hidden="true"></div>'
        ) +
        '<div class="ccd__item-main">' +
          '<p class="ccd__item-title h4">' + title + '</p>' +
          (variant ? '<div class="ccd__item-variant">' + variant + '</div>' : '') +
        '</div>' +
        '<button type="button" class="ccd__remove" data-ccd-remove data-key="' + item.key + '">Remove</button>' +
      '</div>'
    );
  }

  async function refreshDrawer() {
    try {
      var cart = await getCart();

      if (!cart.items || cart.items.length === 0) {
        renderEmpty();
        return;
      }

      var html = '';
      cart.items.forEach(function (item) {
        html += buildItemRow(item);
      });

      itemsEl.innerHTML = html;
      subtotalEl.textContent = formatMoney(cart.total_price || 0);
    } catch (e) {
      console.error('[CartDrawer] refresh error:', e);
      itemsEl.innerHTML = '<div style="padding:20px 0;color:#b40000;">Could not load cart.</div>';
    }
  }

  // ✅ CHANGED: remove by key (this prevents removing all)
  async function removeByKey(key) {
    var fd = new FormData();
    fd.append('updates[' + key + ']', 0);

    var res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    });

    var json = await res.json();
    if (!res.ok) throw new Error(json && json.description ? json.description : 'Remove failed');
    return json;
  }

  overlay.addEventListener('click', closeDrawer);
  btnClose.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') closeDrawer();
  });

  // ✅ CHANGED: loader on remove
  itemsEl.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-ccd-remove]');
    if (!btn) return;

    var key = btn.getAttribute('data-key');
    if (!key) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      await removeByKey(key);
      await refreshDrawer();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Failed to remove item');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.js-open-cart-drawer,[data-open-cart-drawer]');
    if (!opener) return;

    e.preventDefault();
    refreshDrawer().then(openDrawer);
  });

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = (form.getAttribute('action') || '').toLowerCase();
    var isAddForm = action.includes('/cart/add') || form.querySelector('input[name="id"]');
    var force = form.hasAttribute('data-ccd-ajax');

    if (!isAddForm || (!force && action && !action.includes('/cart/add'))) return;

    e.preventDefault();

    var fd = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button');

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: fd
      });

      var json = await res.json();
      if (!res.ok) throw new Error(json && json.description ? json.description : 'Add to cart failed');

      await refreshDrawer();
      openDrawer();
      document.dispatchEvent(new CustomEvent('custom:cart-drawer:opened', { detail: { added: json } }));
    } catch (err) {
      console.error(err);
      alert(err.message || 'Failed to add to cart');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      }
    }
  });

  window.CustomCartDrawer = {
    open: function () { refreshDrawer().then(openDrawer); },
    close: closeDrawer,
    refresh: refreshDrawer
  };

  refreshDrawer();
})();